import { defineMessages } from 'react-intl'

const scope = `procurify.expense.components.TravelCard`

export default defineMessages({
  destinationsLabel: {
    id: `${scope}.destinationsLabel`,
    defaultMessage: 'Destinations: {count}',
  },
  detailsToggleLabel: {
    id: `${scope}.detailsToggleLabel`,
    defaultMessage: 'details',
  },
  submittedDateLabel: {
    id: `${scope}.submittedDateLabel`,
    defaultMessage: 'Submitted date',
  },
  lastModifiedDateLabel: {
    id: `${scope}.lastModifiedDateLabel`,
    defaultMessage: 'Last modified date',
  },
  requestedByLabel: {
    id: `${scope}.requestedByLabel`,
    defaultMessage: 'Requested by',
  },
  departmentLabel: {
    id: `${scope}.departmentLabel`,
    defaultMessage: '{singularSecondaryOrgCategoryLabel}',
  },
  nextApproverLabel: {
    id: `${scope}.nextApproverLabel`,
    defaultMessage: 'Next approver',
  },
  finalApprovedByLabel: {
    id: `${scope}.finalApprovedByLabel`,
    defaultMessage: 'Final approved by',
  },
  deniedByLabel: {
    id: `${scope}.deniedByLabel`,
    defaultMessage: 'Denied by',
  },
  purchasedByLabel: {
    id: `${scope}.purchasedByLabel`,
    defaultMessage: 'Purchased by',
  },
  createdIndicator: {
    id: `${scope}.createdIndicator`,
    defaultMessage: 'Created',
  },
  updatedIndicator: {
    id: `${scope}.updatedIndicator`,
    defaultMessage: 'Updated',
  },
  approvalDelegatedIndicator: {
    id: `${scope}.approvalDelegatedIndicator`,
    defaultMessage: 'Approval delegated',
  },
  tripTableAriaLabel: {
    id: `${scope}.tripTableAriaLabel`,
    defaultMessage: 'Trips for travel {travelId}',
  },
  tripTableTransportationHeader: {
    id: `${scope}.tripTableTransportationHeader`,
    defaultMessage: 'Transportation',
  },
  tripTableDepartureHeader: {
    id: `${scope}.tripTableDepartureHeader`,
    defaultMessage: 'Departure',
  },
  tripTableDepartureDateHeader: {
    id: `${scope}.tripTableDepartureDateHeader`,
    defaultMessage: 'Departure date',
  },
  tripTableArrivalHeader: {
    id: `${scope}.tripTableArrivalHeader`,
    defaultMessage: 'Arrival',
  },
  tripTableArrivalDateHeader: {
    id: `${scope}.tripTableArrivalDateHeader`,
    defaultMessage: 'Arrival date',
  },
  transportDriveLabel: {
    id: `${scope}.transportDriveLabel`,
    defaultMessage: 'Car',
  },
  transportFlightLabel: {
    id: `${scope}.transportFlightLabel`,
    defaultMessage: 'Flight',
  },
  transportRailLabel: {
    id: `${scope}.transportRailLabel`,
    defaultMessage: 'Train',
  },
  transportSailLabel: {
    id: `${scope}.transportSailLabel`,
    defaultMessage: 'Marine',
  },
})
